import { Box, Button, Dialog, DialogActions, Grid, TextField, Typography } from "@material-ui/core"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { EnviarFacturacionAPagadas } from "../../../actions/compras/AuditoriaFactura";
import { startAlerta } from "../../../actions/ui/alertas";

export const ModalEnviarAPagadas = (props) => {
    const [solicitudPago, setSolicitudPago] = useState("");
    const dispatch = useDispatch(); 

    const handleSave = () => {
        if(solicitudPago !== ""){
            dispatch(EnviarFacturacionAPagadas(props.idTramiteCompras, solicitudPago))
        }else{
            dispatch(startAlerta('Debe ingresar el numero de solicitud de pago.', 'error'))
        }
    }
    return (
        <Dialog
            fullWidth
            maxWidth={'sm'}
            open={props.open}
        >
            <Grid>
                <Typography variant="h5" align="center" style={{ margin: '0.5rem' }}>Enviar a pagadas</Typography>
                <Typography  style={{ margin: '0.5rem' }}>Debe ingresar el numero de solicitud de pago.</Typography>
                <Box p={3}>
                   <Grid style={{ padding: '1rem' }}>
                    <TextField 
                        label="Solicitud Pago"
                        multiLine={true}
                        rows={3}
                        rowsMax={8}
                        onChange={(event) => { setSolicitudPago(event.target.value) }}
                        style={{width:'100%'}}
                    />
                   </Grid>
                </Box>
            </Grid>
            <DialogActions>
                <Button color="secondary" onClick={props.close}>Cancelar</Button>
                <Button color="primary" onClick={handleSave}>Enviar</Button>
            </DialogActions>
        </Dialog>
    )
}